import { PageStoryblok } from '@/types/types-storyblok';
import { StoryblokReactComponent } from './componentsMap';
import { StoryblokComponent } from './storyblokComponent';

export const StoryblokPageComponent: StoryblokReactComponent<PageStoryblok> = ({ component, story }) => {
  return <>{component.body?.map((blok, index) => <StoryblokComponent story={story} key={index} component={blok} />)}</>;
};
